<mri-shared-drawer
  [hideHeader]="true"
  [position]="'left'"
  [isOpen]="this.isOpen"
  [clickOverlayToClose]="true"
  [overlayContainerOnly]="true"
  (closeDrawer)="close()"
>
  <div *mriSharedDrawerBody id="menuWindow" class="menuWindow">
    @if (this.activeItem; as contents) {
      <div id="subMenuWindow" class="subMenuWindow">
        <h4 class="mri-heading mri-heading--4 mri-header menu-header">{{ contents.header }}</h4>
        <div class="MenuColumn">
          <div class="menuGroup">
            @for (item of contents.links; track item) {
              @if (isDivider(item)) {
                <ng-container [ngTemplateOutlet]="drawerDivider"></ng-container>
              } @else if (isSection(item)) {
                <ng-container
                  [ngTemplateOutlet]="drawerSection"
                  [ngTemplateOutletContext]="{ $implicit: item }"
                ></ng-container>
              } @else {
                <ng-container
                  [ngTemplateOutlet]="drawerLink"
                  [ngTemplateOutletContext]="{ $implicit: item }"
                ></ng-container>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
</mri-shared-drawer>

<ng-template #drawerSection let-section>
  <div class="menuItem">{{ section.text }}</div>
  <div class="subMenuGroup">
    @for (link of section.links; track link) {
      <ng-container [ngTemplateOutlet]="drawerLink" [ngTemplateOutletContext]="{ $implicit: link }"></ng-container>
    }
  </div>
</ng-template>

<ng-template #drawerLink let-link>
  <div class="menuItem menuAction">
    <a class="mri-link" role="link" [title]="link.text" (click)="routeToUrl(link)">
      <span class="menuLinkText">{{ link.text }}</span>
      @if (link.suffixIcon) {
        <mri-icon class="menuLinkIcon" [icon]="link.suffixIcon"></mri-icon>
      }
    </a>
  </div>
</ng-template>

<ng-template #drawerDivider>
  <hr class="menuDivider" />
</ng-template>
